import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:8000/api';

export const apiClient = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
  timeout: 10000,
});

// Request interceptor - JWT 토큰 자동 추가
apiClient.interceptors.request.use(
  (config) => {
    // localStorage에서 JWT 토큰 가져오기 (Zustand persist로 저장됨)
    const authStorage = localStorage.getItem('auth-storage');
    console.log('[API Client] Auth storage:', authStorage);

    if (authStorage) {
      try {
        const authData = JSON.parse(authStorage);
        const accessToken = authData?.state?.accessToken;
        console.log('[API Client] Access token found:', accessToken ? 'YES' : 'NO');

        if (accessToken) {
          config.headers.Authorization = `Bearer ${accessToken}`;
          console.log('[API Client] Authorization header set:', config.headers.Authorization?.substring(0, 20) + '...');
        }
      } catch (error) {
        console.error('[API Client] Failed to parse auth storage:', error);
      }
    } else {
      console.log('[API Client] No auth storage found');
    }

    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor - 401 에러 처리
apiClient.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    // Handle common errors
    if (error.response) {
      // 401 Unauthorized - JWT 토큰이 유효하지 않음
      if (error.response.status === 401) {
        console.error('Unauthorized - token validation failed');
        // 인증 상태 초기화 (auth storage 삭제하지 않음 - 사용자가 직접 로그아웃하도록)
        // localStorage.removeItem('auth-storage');
        // 로그인 페이지로 리다이렉트하지 않음 - 에러를 그대로 전달
      }
      // Server responded with error
      console.error('API Error:', error.response.data);
    } else if (error.request) {
      // Request made but no response
      console.error('Network Error:', error.message);
    } else {
      // Something else happened
      console.error('Error:', error.message);
    }
    return Promise.reject(error);
  }
);
